function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import { isEmpty, last } from 'lodash';
import CheckCircleIcon from '@heroicons/react/20/solid/CheckCircleIcon';
import { Translate } from "../../../../../I18N";
import { InputField } from "../../../../Components/Forms";
import { Button, Card, Sidepanel } from "../../../../Components/UI";
import uniqueID from "../../../../../../shared/uniqueID";

import { emptyThesaurus, sanitizeThesaurusLabel } from "../helpers";








const ThesauriGroupFormSidepanel = ({
  submit,
  closePanel,
  value,
  showSidepanel
}) => {var _errors$label;
  const {
    watch,
    reset,
    control,
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onSubmit',
    defaultValues: value
  });

  const editMode = value !== undefined && value.label !== '';
  const { append, fields } = useFieldArray({
    control,
    name: 'subRows',
    keyName: 'rowId',
    rules: { minLength: 2 }
  });

  useEffect(() => {
    if (value) {
      reset(value);
    } else {
      reset(emptyThesaurus());
    }
  }, [reset, value]);

  useEffect(() => {
    const subscription = watch((formData) => {var _last;
      const { subRows } = formData;
      if (!isEmpty((_last = last(subRows)) === null || _last === void 0 ? void 0 : _last.label)) {
        append({ label: '', rowId: uniqueID() }, { shouldFocus: false });
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, append]);

  const curateBeforeSubmit = (tValue) => {
    // Sanitize group name and item labels before submitting
    const sanitizedGroupLabel = sanitizeThesaurusLabel(tValue.label);

    const filteredValues = (tValue.subRows || []).
    filter((fValue) => !isEmpty(fValue.label)).
    map((item) => _objectSpread(_objectSpread({},
    item), {}, {
      groupId: tValue.rowId,
      label: sanitizeThesaurusLabel(item.label) })
    );

    submit(_objectSpread(_objectSpread({},
    tValue), {}, {
      label: sanitizedGroupLabel,
      subRows: filteredValues })
    );
    closePanel();
  };

  const renderItem = () =>
  fields.map((localValue, index) => {var _errors$subRows, _errors$subRows$root;return (/*#__PURE__*/
      _jsx("div", { className: "mt-2" }, localValue.rowId, /*#__PURE__*/
      _jsx(Card, { title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Item") }, void 0, /*#__PURE__*/
      _jsx("div", { className: "flex flex-col gap-4" }, void 0, /*#__PURE__*/
      React.createElement(InputField, _extends({
        id: "item-name",
        "data-testid": "thesauri-form-item-name",
        label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Title") },
      register(`subRows.${index}.label`, { required: index < fields.length - 1 }))
      )
      ),
      ((_errors$subRows = errors.subRows) === null || _errors$subRows === void 0 ? void 0 : (_errors$subRows$root = _errors$subRows.root) === null || _errors$subRows$root === void 0 ? void 0 : _errors$subRows$root.type) === 'minLength' && index === 0 && /*#__PURE__*/
      _jsx(Translate, { className: "text-error-700" }, void 0, "This field is required")

      )
      ));}
  );

  return (/*#__PURE__*/
    _jsx(Sidepanel, {
      isOpen: showSidepanel,
      withOverlay: true,
      closeSidepanelFunction: closePanel,
      title: editMode ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Edit group") : /*#__PURE__*/_jsx(Translate, {}, void 0, "Add group") }, void 0, /*#__PURE__*/

    _jsx("form", {
      onSubmit: handleSubmit(curateBeforeSubmit),
      id: "group-thesauri-form",
      className: "flex flex-col h-full" }, void 0, /*#__PURE__*/

    _jsx(Sidepanel.Body, {}, void 0,
    value && value.label === '' && /*#__PURE__*/
    _jsx("div", { className: "p-4 mb-4 border rounded-md shadow-sm border-gray-50 bg-primary-100 text-primary-700" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex items-center w-full gap-1 text-base font-semibold" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "w-5 h-5 text-sm" }, void 0, /*#__PURE__*/
    _jsx(CheckCircleIcon, {})
    ), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Adding a group and its items.")
    ), /*#__PURE__*/
    _jsx("div", { className: "force-ltr" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "You can add one or many items in this form."), /*#__PURE__*/
    _jsx("br", {}), /*#__PURE__*/
    _jsx(Translate, { translationKey: "thesauri new group desc" }, void 0, "Each item created will live inside this group. Once you type the first item name, a new item form will appear underneath it, so you can keep on adding as many as you want."



    )
    )
    ), /*#__PURE__*/

    _jsx(Card, { title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Group") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-4" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "group-name",
      "data-testid": "thesauri-form-item-name",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Name") },
    register('label', { required: true }), {
      hasErrors: !!errors.label })
    )
    ),
    ((_errors$label = errors.label) === null || _errors$label === void 0 ? void 0 : _errors$label.type) === 'required' && /*#__PURE__*/
    _jsx(Translate, { className: "text-error-700" }, void 0, "This field is required")

    ),
    renderItem()
    ), /*#__PURE__*/
    _jsx(Sidepanel.Footer, { className: "bottom-0 px-4 py-3" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      styling: "light",
      onClick: closePanel,
      className: "grow",
      "data-testid": "thesaurus-form-cancel" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, { className: "grow", type: "submit", "data-testid": "thesaurus-form-submit" }, void 0,
    !editMode ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Add group") : /*#__PURE__*/_jsx(Translate, {}, void 0, "Edit group")
    )
    )
    )
    )
    ));

};

export { ThesauriGroupFormSidepanel };